"use strict";

require("../../style/index.less");

require("./index.less");
//# sourceMappingURL=index.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/lib/grid/style/index.js
// module id = 1500
// module chunks = 0